export default __webpack_public_path__ + "f98f41c3da512ea7e8a5ed1420505543.svg";